import { ICreateProjetoUseCase } from "../../../presentation/useCases/create/create_projeto_use_case";
import { CreateProjetoRequestModel, CreateProjetoResponseModel } from "../../models/projeto_model";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class CreateProjetoUseCase implements ICreateProjetoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjeto(
    DescricaoProjeto: string | null,
    NumeroContrato: string | null,
    IdCentroCusto: number | null,

    DataInicio: Date | null,
    DataTermino: Date | null,
    DataInicioreal: Date | null,
    DataTerminoreal: Date | null,

    Contato1: string | null,
    Telefone1: string | null,
    Email1: string | null,

    Contato2: string | null,
    Telefone2: string | null,
    Email2: string | null,

    Escopo: string | null,
    DadosEntrada: string | null): Promise<number> {
    const response = await this.repository.createProjeto(DescricaoProjeto, NumeroContrato, IdCentroCusto, DataInicio, DataTermino, DataInicioreal, DataTerminoreal, Contato1, Telefone1, Email1, Contato2, Telefone2, Email2, Escopo, DadosEntrada  );
    return response.idProjeto
  }
}
